<template>
    <section>
        <div class="weibaoApply">
            <el-form :model="questionForm" ref="questionForm" label-position="left" label-width="100px"
                style="width: 90%; margin-left: 5%">
                <el-form-item label="申请类别" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-radio-group v-model="questionForm.maintenanceType" style="float: left;margin-top: 10px;">
                        <el-radio label="0">维修</el-radio>
                        <el-radio label="1">保养</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="维保原因" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-input placeholder="请输入维保原因" style="width: 100%" v-model="questionForm.reason" />
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button style="margin-left: 10px" size="small" type="primary" @click="comit"
                    v-preventReClick>提交</el-button>
                <el-button @click="closeDialog" size="small">取消</el-button>
            </div>
        </div>
    </section>
</template>
<script>
import { addDeviceMaintenances } from '../../api/api'
export default {
    props: ['deviceinfo'],
    data() {
        return {
            questionForm: {
                reason: "",
                maintenanceType: "",
            },
        }
    },
    methods: {
        comit() {
            let deviceId = this.deviceinfo.map(item => item.id).join()
            var userinfo = JSON.parse(localStorage.getItem("user"))

            let _params = {
                deviceIds: deviceId,
                mainType: this.questionForm.maintenanceType,
                reason: this.questionForm.reason,
                userId: userinfo.userId
            }
            addDeviceMaintenances(_params).then(datas => {
                let { status, data, message } = datas
                if (status == 300) {
                    this.$message({
                        message: message,
                        type: 'warning'
                    });
                } else if (status == 200) {
                    this.$message({
                        message: "申请成功，等待审核通过",
                        type: 'success'
                    });
                    this.$emit('select')
                    this.closeDialog();
                } else {
                    this.$message({
                        message: "申请失败",
                        type: 'success'
                    });
                }
            })
        },
        closeDialog() {
            this.questionForm.reason = ""
            this.questionForm.maintenanceType = ""
            this.$emit('func')
        }
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/common/WeibaoApply.vue